import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import Button from '@material-ui/core/Button';
import RenderSelectField from "../inputs/renderSelectField";
import MenuItem from "@material-ui/core/MenuItem";
import RenderCheckboxField from "../inputs/renderCheckboxField";
import FormSelectItemValidation from "../validation/forms/formSelectItemValidation";
import RenderSuggestionInput from '../inputs/renderSuggestionInput';

const ScoreTypeForm =  (props) =>{
  const {submitStoreType, handleSubmit, storeTypes, resetTableFilters, citiesSuggestions} = props;
  return (
    <form
      onSubmit={handleSubmit(submitStoreType)}
      autoComplete={'off'}
      autoCapitalize={'off'}
      autoCorrect={'off'}
      spellCheck={'off'}
    >
      <div className={'form-row'}>
        <div className={'form-group col'}>
          <Field
            validate={FormSelectItemValidation}
            name="scoreType"
            label={'Score type'}
            component={RenderSelectField}
            required
            fullWidth
          >
            {
              storeTypes.map( type => (
                <MenuItem value={type.id} key={type.id}>{type.name}</MenuItem>
              ))
            }
          </Field>
        </div>
      </div>
      <div className={'form-row'}>
        <div className={'form-group col-6'}>
          <Field
            disabled={!props.scoreTypeFormValue}
            name="city"
            label={'City'}
            component={RenderSuggestionInput}
            type="text"
            fullWidth
            suggestions={citiesSuggestions
              .map(item => ({label: item.city}))
            }
            customSuggestionsContainerOpen={{
              position: 'absolute',
              zIndex: 1,
              left: 0,
              right: 0,
              maxHeight: '200px',
              overflowY: 'auto'
            }}
            handleSuggestions={() => null}
            fetchSuggestions={props.fetchCitiesSuggestions}
            shouldRenderSuggestions={() => {return true}}
            id={'city'}
          />
        </div>
        <div className={'form-group col-6'}>
          <Field
            disabled={!props.scoreTypeFormValue}
            name="name"
            label={'Name'}
            component={RenderSuggestionInput}
            type="text"
            fullWidth
            suggestions={props.storeSuggestions.map(item => ({label: item.name}))}
            handleSuggestions={props.changeStoresState}
            fetchSuggestions={props.fetchStoresSuggestions('name', 5)}
            id={'name'}
          />
        </div>
      </div>
      <div className={'form-row'}>
        <div className={'form-group col-6'}>
          <Field
            disabled={!props.scoreTypeFormValue}
            name="enterSoftCode"
            label={'Entersoft Code'}
            component={RenderSuggestionInput}
            type="text"
            fullWidth
            suggestions={props.storeSuggestions.map(item => ({label: item.enterSoftCode}))}
            handleSuggestions={props.changeStoresState}
            fetchSuggestions={props.fetchStoresSuggestions('enterSoftCode', 5)}
            id={'enterSoftCode'}
          />
        </div>
        <div className={'form-group col-6'}>
          <Field
            disabled={!props.scoreTypeFormValue}
            name="code"
            label={'ID Code'}
            component={RenderSuggestionInput}
            type="text"
            fullWidth
            suggestions={props.storeSuggestions.map(item => ({label: item.dwId}))}
            handleSuggestions={props.changeStoresState}
            fetchSuggestions={props.fetchStoresSuggestions('dwId', 8)}
            id={'dwId'}
          />
        </div>
      </div>
      <div className={'form-group'}>
        <Field
          name="displayStoresWithoutScores"
          label={'Display stores without scores'}
          component={RenderCheckboxField}
          type="text"
        />
      </div>
      <div className={'form-group'}>
        <Button type={'submit'} variant="contained" color="primary" className={'mr-3'}>
          {'Generate score table'}
        </Button>
        <Button variant="contained" color="secondary" onClick={resetTableFilters}>
          {'Reset Table'}
        </Button>
      </div>
    </form>
  )

};

export default reduxForm({
  enableReinitialize: true,
  form: 'scoreTypeForm',
})(ScoreTypeForm);



// WEBPACK FOOTER //
// ./src/components/scoreRecord/scoreTypeForm.js